<div class="container-fluid">
  <h2 class="text-siscomeTot underline">{{ page.name === 'edit' ? 'Editar' : page.name === 'view' ? 'Visualizar' :'Criar' }} Zona</h2>
  <mat-card>
    <mat-card-content>
      <form [formGroup]="zoneForm" (keydown.enter)="$event.preventDefault()" (ngSubmit)="onSubmit(page.name)">
        <div class="row">
          <mat-form-field appearance="outline" class="form-group col-6">
            <mat-label class="text-siscomeMed">Nome</mat-label>
            <input class="form-control" [(ngModel)]="zone.name" [ngClass]="{ 'is-invalid': submitted && zoneForm.controls['name'].hasError('required' || 'invalid') }"
             id="name" matInput placeholder="Nome da zone" required
              name="name" formControlName="name">
              <div class="invalid-feedback" *ngIf="zoneForm.controls['name'].hasError('required')">
                o Campo é Obrigatório
              </div>
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-group col-3">
            <mat-label class="text-siscomeMed">País</mat-label>
            <select matNativeControl  [(ngModel)]="country"  id="country" [compareWith]="equals" 
              (change)="getCities(country)" [ngClass]="{ 'is-invalid': submitted && zoneForm.controls['country'].hasError('required' || 'invalid') }"
              name="country" formControlName="country" required>
              <option *ngFor="let pais of paises; let i = index;" [selected]="pais.id === country" label="{{pais.name}}"  [ngValue]="pais"></option>
              </select>
              <div class="invalid-feedback" *ngIf="zoneForm.controls['country'].hasError('required')">
                o Campo é Obrigatório
              </div>
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-group col-3">
            <mat-label class="text-siscomeMed">Cidade</mat-label>
            <mat-hint class="text-siscomeMed">Escolher País primeiro</mat-hint>
            <select matNativeControl  [(ngModel)]="zone.city"  id="city" [compareWith]="equals" 
             [ngClass]="{ 'is-invalid': submitted && zoneForm.controls['city'].hasError('required' || 'invalid') }"
              name="city" formControlName="city" required>
              <option *ngFor="let city of cidades; let i = index;" [selected]="city.id === zone.city.id" label="{{city.name}}"  [ngValue]="city"></option>
              </select>
              <div class="invalid-feedback" *ngIf="zoneForm.controls['city'].hasError('required')">
                o Campo é Obrigatório
              </div>
          </mat-form-field>
        </div>
      </form>
    </mat-card-content>
    <mat-card-actions align="center">
      <button mat-raised-button *ngIf="page.name !== 'view'" class="siscomeTot large-button"  color="primary" (click)="onSubmit(page.name)">
        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
        {{ page.name === 'edit' ? 'Guardar' : 'Criar' }}</button>
        <button mat-raised-button *ngIf="page.name === 'view'"   class="siscomeTot" (click)="editar()" color="grey">Editar
        </button>
        <button mat-raised-button   class="grey" (click)="cancelar()" color="grey">{{ page.name === 'create' ? 'Cancelar' : 'Voltar' }}
        </button>
    </mat-card-actions>
  </mat-card>
</div>
